import Header from "@/components/layout/Header";
import Footer from "@/components/layout/Footer";
import AuthForm from "@/components/auth/AuthForm";
import { useAuth } from "@/context/AuthContext";
import { Navigate, useSearchParams } from "react-router-dom";

export default function AuthPage() {
  const { user, loading } = useAuth();
  const [searchParams] = useSearchParams();
  const returnTo = searchParams.get('returnTo');

  // Redirect if already signed in
  if (user && !loading) {
    return <Navigate to={returnTo || "/"} state={{ from: "/auth" }} replace />;
  }

  return (
    <div className="min-h-screen flex flex-col">
      <Header />
      <main className="flex-1 flex items-center justify-center py-8">
        <div className="w-full max-w-md px-4">
          <AuthForm />
        </div>
      </main>
      <Footer />
    </div>
  );
}
